import { checkGivenDateIsAfterCurrentDate, fromNow, getMomentDate } from "../../utils/dateUtils";
import { findServiceInfoByServiceId } from "../../utils/commonUtils";

export const campaignStatus = {
  1: "SENDING",
  2: "SCHEDULED",
  10: "THROTTLE_LIMIT_REACHED",
  15: "PENDING",
  30: "SENT",
  50: "CAMPAIGN_STATUS_MARGIN",
  51: "RECORD_LIMIT_EXCEEDED",
  52: "STOPPED",
  53: "PAUSED",
  54: "FAILED",
  55: "FORCE_STOP",
};
const DEFAULT_MAXIMUM_SUPPORTED_RECORDS_FOR_CAMPAIGN_COUNT = 500;

export const getMaximumSupportedRecordsForCampaign = (appProperties, integId) => {
  if (!appProperties?.installedApps || !integId) {
    return DEFAULT_MAXIMUM_SUPPORTED_RECORDS_FOR_CAMPAIGN_COUNT;
  }

  const integration = appProperties.installedApps.find((app) => app?.integProps?.integId === integId);
  var serviceId = integration?.right?.service_id;

  const serviceInfo = findServiceInfoByServiceId(appProperties, serviceId);
  const limit = serviceInfo?.maxRecordsPerCampaign;

  return limit || DEFAULT_MAXIMUM_SUPPORTED_RECORDS_FOR_CAMPAIGN_COUNT;
};

export const getMaximumSupportedRecordsForCampaignMessage = (count) => (
  <div className="mt-1">
    {`Supports upto ${count} records.
    For more, email us at assist@hellosend.com`}
  </div>
);

export const campaignStatusNameMap = {
  sending: "In Progress",
  sent: "Completed",
  scheduled: "Scheduled",
  paused: "Paused",
  failed: "Failed",
  pending: "Sent",
  force_stopped: "Not sent",
  force_stop: "Stopped",
  stopped: "Stopped",
  record_limit_exceeded: "Not sent",
};

export function getStatusTextFromTimeInMillis(targetDate, statusText) {
  if (
    statusText === "failed" ||
    statusText === "paused" ||
    statusText === "force_stop" ||
    statusText === "record_limit_exceeded" ||
    statusText === "stopped" ||
    !targetDate ||
    !checkGivenDateIsAfterCurrentDate(targetDate)
  ) {
    return campaignStatusNameMap[statusText];
  }

  const formattedTime = fromNow(getMomentDate(targetDate));
  return `Sending in ${formattedTime}`;
}

export const getClassNameForCampaignStatus = (statusText) => {
  let statusClassName = null;
  switch (statusText?.toLowerCase()) {
    case "sending":
    case "scheduled":
      statusClassName = "sendingOrScheduledStatus";
      break;
    case "sent":
      statusClassName = "sentStatus";
      break;
    case "pending":
      statusClassName = "pendingStatus";
      break;
    case "stopped":
      statusClassName = "stoppedStatus";
      break;
    case "paused":
      statusClassName = "pausedStatus";
      break;
    case "force_stop":
      statusClassName = "forceStoppedStatus";
      break;
    case "record_limit_exceeded":
      statusClassName = "forceStoppedStatus";
      break;
    default:
      statusClassName = "";
      break;
  }
  return statusClassName;
};

export const getClassNameForCampaignType = (type) => {
  if (type === "IMMEDIATE") {
    return "immediateBadge";
  } else {
    return "scheduledBadge";
  }
};

export const getCampaignStatusFromStatusCode = (code) => {
  return campaignStatus[code]?.toLowerCase();
};
export const checkIsRunningCampaign = (code) => {
  if (campaignStatus[code] === "SENDING" || campaignStatus[code] === "SCHEDULED") {
    return true;
  } else return false;
};
